import { Routes } from '@angular/router';

export const VehiclesRoutes: Routes = [
  {
    path: 'vehicles',
    title: 'Vehículos',
    data: { icon: 'directions_car', permission: 'vehicles.view' },
    loadComponent: () => import('@features/vehicles/vehicles.component'),
    children: [
      {
        path: '',
        title: 'Vehículos',
        loadComponent: () => import('@features/vehicles/views/overview/overview.component'),
      },
      {
        path: ':vehicleId',
        children: [
          {
            path: 'profile',
            title: 'Perfil del vehículo',
            data: { backFallback: '/vehicles' },
            loadComponent: () =>
              import('@features/vehicles/views/profile/profile.component'),
          },
          {
            path: 'drivers',
            title: 'Conductores del vehículo',
            data: { backFallback: '/vehicles' },
            loadComponent: () =>
              import('@features/vehicles/views/vehicle-drivers/vehicle-drivers.component'),
          },
          {
            path: 'attachments',
            title: 'Archivos del vehículo',
            data: { backFallback: '/vehicles' },
            loadComponent: () =>
              import('@features/vehicles/views/vehicle-attachments/vehicle-attachments.component'),
          },
          {
            path: 'expirations',
            title: 'Vencimientos del vehículo',
            data: { backFallback: '/vehicles' },
            loadComponent: () =>
              import('@features/vehicles/views/vehicle-expirations/vehicle-expirations.component'),
          },
        ],
      },
    ],
  },
];
